import './wrong-lesson-length-warning-popup.css'
const WrongLessonLengthWarningPopup = () => {
    return (
        <div className='wrong-lesson-length-warning-popup'>It looks like these lessons are not the same length as in the database. Make sure the family is ok with this lesson length and then make the appropriate changes to the database. We don't want teachers going long on their lesson and then surprise charging the family for the extra time.</div>
    )
}
export default WrongLessonLengthWarningPopup